import React from 'react'

function ProcessingView() {
    return (
        <div>ProcessingView</div>
    )
}

export default ProcessingView